(() => {
  const mediaQuery = window.matchMedia('(max-width: 749px)');

  function applyFooterMenus(root = document) {
    root.querySelectorAll('[data-footer-menu-toggle]').forEach((button) => {
      if (button.dataset.footerMenuReady !== 'true') {
        button.dataset.footerMenuReady = 'true';
        button.addEventListener('click', () => {
          if (!mediaQuery.matches) return;
          const content = document.getElementById(button.getAttribute('aria-controls'));
          if (!content) return;
          const expanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', String(!expanded));
          content.hidden = expanded;
        });
      }

      const content = document.getElementById(button.getAttribute('aria-controls'));
      if (!content) return;
      button.setAttribute('aria-expanded', String(!mediaQuery.matches));
      content.hidden = mediaQuery.matches;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applyFooterMenus());
  } else {
    applyFooterMenus();
  }

  mediaQuery.addEventListener('change', () => applyFooterMenus());
  document.addEventListener('shopify:section:load', (event) => applyFooterMenus(event.target));
})();
